<div class="container-fluid p-0">
    <!-- login page start-->
    <div class="authentication-main">
		<div class="row">
			<div class="col-md-12">
				<div class="authentication-box">
					<div class="text-center">
					</div>
					<div class="card mt-4">
						<div class="card-body">
							<div class="text-center">
								<h4>Connexion</h4>
							</div>
							<div class="theme-form">
								<div class="form-group">
									<label for="email" class="col-form-label pt-0">Email</label>
									<input class="form-control" type="email" id="email" required="" [(ngModel)]="email">
								</div>
								<!-- Password input label -->
								<label for="password" class="col-form-label label-psw">Mot de passe</label>
								<div class="form-group input-group">
									<input  [type]="fieldTextType ? 'text' : 'password'" class="form-control" type="password" id="password"required="" [(ngModel)]="pass" (keydown.enter)="verifyLogin()">
									<!-- Icon eye: show/hide psw -->
									<div class="input-group-append">
										<span class="input-group-text eye-btn">
										  <i class="fa"
										  [ngClass]="{
											'fa-eye-slash': !fieldTextType,
											'fa-eye': fieldTextType
										  }"
										  (click)="toggleFieldTextType()" 
										  ></i>
										</span>
									 </div>
								</div>     
								<div class="forget-pwd" [routerLink]="['/bo/mot-de-passe-oublie']" routerLinkActive="active" >
									Mot de passe oublié
								</div>
								<div class="form-group form-row mt-3 mb-0 login-button-block">
									<button class="btn btn-block login-button" type="submit" (click)="verifyLogin()">Se connecter</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
    <!-- login page end-->
</div>